// A customer's contact details must be the customer's. On 28/29-Sep several
// client profiles were saved with the BDM's own name and address in them
// ("BDM 07" / rbmbdm07@gmail.com) — typed in as "our contact person", or
// filled in by the browser's saved profile — and every quotation and email
// for that client then went to RBM instead of the client.

const STAFF_NAME = /^\s*bdm\s*[-_.#]?\s*\d{0,2}\s*$/i;
const STAFF_EMAIL = [
  /^rbmbdm\d*@/i,
  /@rbmoilcorporation\.(in|com)$/i,
  /^rbmoilcorp(oration)?@/i,
];

export const isStaffName = (name?: string | null) => STAFF_NAME.test(String(name || ''));
export const isStaffEmail = (email?: string | null) => {
  const e = String(email || '').trim();
  return !!e && STAFF_EMAIL.some((rx) => rx.test(e));
};

/**
 * Why this save would put RBM's own identity into a customer record, or '' if
 * it would not. Only values that CHANGE are checked, so an imported record that
 * already carries one can still be edited for something else.
 */
export function staffIdentityProblem(
  next: { name?: string; email?: string },
  prev: { name?: string; email?: string } = {},
): string {
  const changed = (a?: string, b?: string) => String(a || '').trim().toLowerCase() !== String(b || '').trim().toLowerCase();
  if (changed(next.name, prev.name) && isStaffName(next.name)) {
    return `"${String(next.name).trim()}" is an RBM staff name. Enter the customer's own contact person (or leave it blank to use the company name).`;
  }
  if (changed(next.email, prev.email) && isStaffEmail(next.email)) {
    return `${String(next.email).trim()} is an RBM address. Enter the customer's own email, or leave it blank.`;
  }
  return '';
}
